/**
 * Split a diagnostics log pull into Agent (companion) and Service sections.
 * Headers must match backend/src/utils/diagnosticsLogBundle.ts and the Windows agent.
 */
export const AGENT_LOG_SECTION_HEADER = '===== Agent (companion) =====';
export const SERVICE_LOG_SECTION_HEADER = '===== Service =====';

export function splitDiagnosticsLogBundle(content: string): {
  bundled: boolean;
  agent: string;
  service: string;
} {
  const text = content ?? '';
  const agentAt = text.indexOf(AGENT_LOG_SECTION_HEADER);
  const serviceAt = text.indexOf(SERVICE_LOG_SECTION_HEADER);
  if (agentAt === -1 && serviceAt === -1) {
    return { bundled: false, agent: text.trim(), service: '' };
  }

  if (serviceAt === -1) {
    return {
      bundled: true,
      agent: text.slice(agentAt + AGENT_LOG_SECTION_HEADER.length).trim(),
      service: '',
    };
  }

  if (agentAt === -1 || serviceAt < agentAt) {
    return {
      bundled: true,
      agent: text.slice(0, serviceAt).trim(),
      service: text.slice(serviceAt + SERVICE_LOG_SECTION_HEADER.length).trim(),
    };
  }

  return {
    bundled: true,
    agent: text.slice(agentAt + AGENT_LOG_SECTION_HEADER.length, serviceAt).trim(),
    service: text.slice(serviceAt + SERVICE_LOG_SECTION_HEADER.length).trim(),
  };
}
